<ll-titulo>{{ duda?.duda }}</ll-titulo>
<duda [dudaId]="id" (dudaChange)="onReady($event)"></duda>
